<template>
    <div class="filling-goods-div">
        <div style="padding-top: 5px;font-size: 16px">坯布自动领料出库</div>
        <div class="filling-goods-head">
            <div class="filling-goods-head-div">
                <div class="head-input-div">
                    <div style="width: 20%;text-align: left">编号:</div>
                    <input style="width: 80%" readonly="readonly" class="number" v-model="out_num" >
                </div>
                <div class="head-input-div">
                    <div style="width: 20%;text-align: left">行数:</div>
                    <input style="width: 80%" readonly="readonly" :value="data.length">
                </div>
            </div>
        </div>
        <span style="color: red" v-if="hostcs">测试服</span>
        <div style="display: flex;justify-content: space-between;align-items: center" v-if="outNumber === '未出库'">
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
            <div>
                <input id="gck_number-input" class="get-input" @keyup.enter="add_mx(gck_number_data)" ref="getGCKInpot"
                       v-model="gck_number_data" v-on:blur="hideMessage('gck_number_data')" readonly autocomplete="off">
            </div>
        </div>
        <div :style="style">
            <div class="goods-info-two" v-for="(i,index) in data" :key="index">
            </div>
        </div>
        <div class="filling-goods-bottom">
            <van-button type="warning"  class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button v-if="outNumber === '未出库'" type="info"  class="bottom-button" @click="fillingGoods()">确认出库</van-button>
            <van-button v-if="outNumber !== '未出库'" type="default"  class="bottom-button" style="background-color: darkgray">确认出库</van-button>
            <van-button v-if="outNumber !== '未出库'" type="info"  class="bottom-button" @click="revocation(id)">撤销出库</van-button>
            <van-button v-if="outNumber === '未出库'" type="default" class="bottom-button" style="background-color: darkgray">撤销出库</van-button>
            <van-button type="warning"  class="bottom-button" style="margin: 0" @click="more_show = true">
                更多
            </van-button>
        </div>
        <van-popup v-model="more_show"  position="bottom">
            <div class="more-class"><van-icon name="scan" size="1rem" @click="gourl('fillingGoods')"/></div>
            <div class="more-class" style="padding: 10px 0"><span style="font-size: 20px;" @click="all_delete()">整单删除</span></div>
        </van-popup>
    </div>
</template>

<script>
  import $ from 'jquery'
  import {mapState,mapMutations} from 'vuex'
  import { Dialog } from "vant";
  import { Toast } from 'vant';
  export default {
    name: "fillingGoods",
    data(){
      return{
        hostcs:false,
        more_show: false,
        ray:'扫描中',
        id: '',
        supplier_xh: '',
        data:[],
        style: '',
        out_num:'',
        infoType:'1111',
        gck_number_data_haveAll:{},
        gck_number_data:'',
        fillingGoodsType:true,
        revocationType:true,
        outNumber:'未出库',
      }
    },
    mounted(){
      if(this.$route.query.id !== undefined){
        this.getIdData(this.$route.query.id)
      }
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      this.style = 'text-align: left;width: 100%;height: '+ h*0.66 +'px;overflow:scroll'
      setTimeout(()=>{
        if(this.outNumber === '未出库'){
          this.focus()
        }
      },500)
      if(window.location.host.indexOf('cspda') !== -1){
        this.hostcs = true
      }
    },
    methods:{
      gck_input(){
        this.$refs.getGCKInpot.focus()
        this.$refs.getGCKInpot.setAttribute('readonly', 'readonly');
        setTimeout(() => {
          this.$refs.getGCKInpot.removeAttribute('readonly');
        }, 200);
      },
      all_delete(){
        if(this.outNumber === '已出库'){
          Toast('已装箱不能删除');
          return
        }
        Dialog.confirm({
          message: '确定要删除当前装箱单吗？'
        }).then(async () => {
          let s = await this.get(this.APIOBJ.outDel,{id:this.id})
          Toast(s.data.msg);
          if(s.data.status === 1){
            setTimeout(()=>{
              this.$router.push('/home');
            },500)
          }
        });
      },
      hideMessage(title){
        if(title === 'gck_number_data'){
          if(this.gck_number_data === ''){
            this.ray='已暂停，点击我继续扫码'
          }
        }
      },
      holdRay(){
        this.ray='扫描中'
        this.gck_input()
      },
      focus() {
        this.$refs.getIDInpot.focus()
        this.$refs.getIDInpot.setAttribute('readonly', 'readonly');
        setTimeout(() => {
          this.$refs.getIDInpot.removeAttribute('readonly');
        }, 200);
      },
      gourl(url){
        url = 'http://www.lcyjfz.com/home/scan?url=' + url
        window.location.href = url
      },
      async add_mx(gck_number_title){
        if(this.gck_number_data_haveAll[gck_number_title] !== undefined){
          Toast('明细码不能重复')
          this.gck_number_data = ''
          return
        }
        this.gck_number_data_haveAll[gck_number_title] = ''
        this.gck_input()
        this.gck_number_data = ''
      },
      deleteData(index,gck_number_data) {
        if(this.outNumber === '已出库'){
          Toast('已装箱不能删除');
          return
        }
        Dialog.confirm({
          message: '确定要删除该明细吗？'
        }).then(() => {
          this.data.splice(index,1)
          delete this.gck_number_data_haveAll[gck_number_data]
          setTimeout(()=>{
          },0)
        });
      },
      go_index(){
        this.$router.push('/home')
      },
      go_scan_url(){
        let url = 'http://cs.lcyjfz.com/home/scan?id=' + this.$route.query.id || ''
        window.location.href = url
      },
      async getIdData(id){//订单详情页
        let idData = await this.get(this.APIOBJ.out_detail,{id})
        this.data = idData.data.data.out_detail
        this.outNumber = idData.data.data.out.status
        for(let i of idData.data.data.out_detail){
          this.gck_number_data_haveAll[i.mxm] = ''
        }
        this.infoType = ''
        this.out_num = idData.data.data.out.out_num
        this.id = id
      },
      async getFGIdData(FGid){
      },
      async fillingGoods(){
        if(this.data.length === 0){
          return
        }
        if(!this.fillingGoodsType){
          Toast('不要连续装箱')
          return
        }
        this.fillingGoodsType = false
        let out_info
        if(this.id === ''){
          let data = {
            gck_number:'',
            number:'',
            num:''
          }
          for(let i of this.data){
            if(i['all_num'] === ''){
              Toast('数量不能为空');
              this.fillingGoodsType = true
              return
            }
            data.gck_number += i.gck_number+','
            data.number += i.number+','
            data.num +=  i['all_num']+','
          }
          for(let i in data){
            data[i] = data[i].substring(data[i].length-1)===','?data[i].substring(0,data[i].length-1):data[i]
          }
          out_info = await this.get(this.APIOBJ.doOut,data)
        }else {
          let data = {
            gck_number:'',
            number:'',
            num:'',
            id:this.id
          }
          for(let i of this.data){
            if(i['all_num'] === ''){
              Toast(`${i.mxm}数量为空`);
              this.fillingGoodsType = true
              return
            }
            data.gck_number += (i.mxm || i.gck_number)+','
            data.number += i.number+','
            data.num += i['all_num']+','
          }
          for(let i in data){
            if(i !== 'id'){
              data[i] = data[i].substring(data[i].length-1)===','?data[i].substring(0,data[i].length-1):data[i]
            }
          }
          out_info = await this.get(this.APIOBJ.outEdit,data)
        }
        if(out_info.data.status === 1){
          Toast('成功')
        }
        this.id = out_info.data.data.out_detail[0].oid
        this.fillingGoodsType = true
        this.outNumber = out_info.data.data.out.status
        this.infoType = ''
        this.out_num = out_info.data.data.out.out_num
      },
      async revocation(id){
        if(!this.revocationType){
          return
        }
        this.revocationType = false
        let out_info = await this.get(this.APIOBJ.backOut,{id:id})
        this.outNumber = '未出库'
        if(out_info.data.status === 1){
          Toast('已撤销')
        }
        this.infoType = '1111'
        this.revocationType = true
      }
    }
  }
</script>

<style lang="less">
    @import "../style/outOrderInfo.less";
</style>